import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared.module';

import {LoginComponent} from './components';


@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [LoginComponent],
  providers: []
})
export class LoginModule { }

export {LoginComponent};
